/**
 * `createdAt` 계열 날짜값 → epoch ms.
 *
 * `moments/view/post-sort` 와 `moments/analysis/canonical-ranking` 둘이 읽는다. 한쪽에 두면
 * view → analysis 방향 의존이 생겨서 아래 계층인 domain 에 뒀다.
 */
import type { FirestoreOrIsoDate } from 'src/types/moments/moment-domain';

/**
 * `createdAt`은 ISO 문자열·epoch 숫자·Firestore Timestamp 객체가 모두 온다.
 * 문자열·숫자가 아니거나 해석에 실패하면 `NaN` 을 낸다.
 */
export const toEpochMs = (value: FirestoreOrIsoDate): number =>
  (typeof value === 'string' || typeof value === 'number'
    ? new Date(value).getTime()
    : Number.NaN);
